import * as React from 'react';
import Button from '@mui/material/Button';
import { Box, CircularProgress, Grid, Stack, Typography } from '@mui/material';
import {getVideoPlacements } from '../Api';
import { useNavigate } from 'react-router-dom';
import PromoBannerDto from '../models/dtos/PromoBannerDto';
import PromoBannerCard from '../components/PromoBannerCard';
import ShopItemCard from '../components/ShopItemCard';
import ShopItemDto from '../models/dtos/ShopItemDto';
import VideoPlacementDto from '../models/dtos/VideoPlacementDto';
import VideoPlacementCard from '../components/VideoPlacementCard';
import VideoRewardConfigModal from '../components/VideoRewardConfigModal';
import SettingsIcon from '@mui/icons-material/Settings';

export const formatRevenue = (revenue: number) => {
    return revenue.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
    });
}

export default function VideoPlacementsPage() {
    const [state, setState] = React.useState({
        itemsLoaded: false,
        items: [] as VideoPlacementDto[]
    });
    const [configModalOpen, setConfigModalOpen] = React.useState(false);

    const navigate = useNavigate()


    React.useEffect(() => {

        const fetchData = async () => {
            let items = await getVideoPlacements();
            setState(prevState => ({ ...prevState, items: items ?? [], itemsLoaded: true }));
        }

        fetchData();
    }, [])

    return (
        <Stack gap="50px 50px" sx={{ mx: 5, my: 5 }} justifyContent='center' alignItems='center'>
            <Grid container spacing={2} columns={{ xs: 1, sm: 2, md: 4, lg: 5 }} justifyContent="flex-end">
                <Grid item xs={1} key="generalStatsButton" alignContent="center">
                    <Button variant="contained" fullWidth={true} style={{ height: '54px' }} onClick={() => navigate('/video-placements/stats')}>General stats</Button>
                </Grid>
                <Grid item xs={1} key="settingsButton" alignContent="center">
                    <Button 
                        variant="outlined" 
                        fullWidth={true} 
                        style={{ height: '54px' }} 
                        startIcon={<SettingsIcon />}
                        onClick={() => setConfigModalOpen(true)}
                    >
                        Settings
                    </Button>
                </Grid>
            </Grid>
            <Typography variant="h3">Video placements</Typography>
            {!state.itemsLoaded ? <Grid item xs={2}><CircularProgress size='25%' style={{ marginBottom: '32px', marginLeft: '35%' }} /></Grid> : <div />}
            <Grid container spacing={5} columns={{ xs: 1, sm: 1, md: 2, lg: 3, xl: 4 }}>
                <Box width='100%' />
                {
                    state.items.map(x =>
                        <Grid item xs={1} key={x.id}>
                            <VideoPlacementCard {...{item: x, showEdit: true}} />
                        </Grid>)
                }
            </Grid>
            <VideoRewardConfigModal
                open={configModalOpen}
                onClose={() => setConfigModalOpen(false)}
                onSave={() => {
                    // Optionally reload placements or show success message
                    setConfigModalOpen(false);
                }}
            />
        </Stack >
    );
}